import Reveal from "./Reveal";
import { STEPS } from "@/data/content";

const HowItWorks = () => (
  <section id="process" data-testid="process-section" className="py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center max-w-3xl mx-auto">
        <span className="text-sm font-bold uppercase tracking-wider text-primary">Simple Process</span>
        <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-foreground">How It Works</h2>
        <p className="mt-4 text-muted-foreground text-base md:text-lg">
          Getting your package delivered is as simple as 1-2-3-4. No hassle, no stress.
        </p>
      </Reveal>

      <div className="mt-12 md:mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.num} delay={i * 0.1} className="relative text-center">
              {i < STEPS.length - 1 && (
                <span className="hidden lg:block absolute top-10 left-[60%] w-full border-t-2 border-dashed border-primary/25" />
              )}
              <div className="relative mx-auto w-20 h-20 rounded-2xl bg-gradient-to-br from-primary/10 to-primary/5 flex items-center justify-center">
                <Icon className="w-8 h-8 text-primary" />
                <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-primary text-white text-[11px] font-bold flex items-center justify-center">
                  {s.num}
                </span>
              </div>
              <h3 className="mt-6 text-lg font-bold text-foreground">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground max-w-xs mx-auto">{s.body}</p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default HowItWorks;
